// @ts-nocheck
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import preferencesRoutes from '@/routes/preferences';
import { useUserType } from '@/hooks/query';

export default function DashboardContentRoute() {
  const userType = String(useUserType() || '').toLowerCase();

  return (
    <Route pathname="/preferences">
      <Switch>
        {preferencesRoutes.map((route, index) => {
          const RouteComponent = route.component;

          return (
            <Route
              key={index}
              path={`${route.path}`}
              exact={route.exact}
            >
              {Array.isArray(route.userTypes) &&
              !route.userTypes
                .map((type) => String(type || '').toLowerCase())
                .includes(userType) ? (
                <Redirect to={{ pathname: '/' }} />
              ) : (
                <RouteComponent />
              )}
            </Route>
          );
        })}
      </Switch>
    </Route>
  );
}
